<template>
  <div class="protocol login-protocol">
    <navigation v-if="!$route.query.hideTitle">《个人信息使用授权书》</navigation>
    <section class="header">
      个人信息使用授权书
    </section>
    <section class="content">
      <p class="text tab-2"><strong>个人信息使用授权书</strong></p>
      <p class="text tab-2"><strong>重要提示：</strong></p>
      <p class="text tab-2"><strong>为了保障您的合法权益，请您务必审慎阅读、充分理解本授权书各条款内容（特别是免除或者限制</strong><strong>重庆市崇天小额贷款有限公司（以下称“被授权人”）责任的条款和对您权利进行限制的条款等），并严格遵守本授权书。限制、免责条款或者其他涉及您重大权益的条款会以加粗等形式提示您重点注意。</strong></p>
      <p class="text tab-2"><strong>除非您已充分阅读、完全理解并接受本授权书所有条款，否则您无权使用相关服务。您点击“同意”或“下一步”，或您使用相关服务，或以其他任何明示或者默示方式表示接受本授权书的，均视为您已充分理解本授权书所有条款的含义及相应的法律后果并同意签署本授权书。本授权书即在您与被授权人之间产生法律效力。</strong></p>
      <p class="text tab-2">重庆市崇天小额贷款有限公司：</p>
      <div>
        <p class="text tab-2">一、本人知悉并同意被授权人收集本人的<strong>姓名、年龄、身份证号、所在城市、申请额度、手机号、信用情况、工作年限、收入情况、房产信息、车辆信息、社保及公积金信息、商业保险信息、企业主信息、纳税信息等个人信息以及Android ID、IMEI、IMSI、MAC地址等个人常用设备信息</strong>，并同意授权被授权人将该等信息提供给合作方重庆领易付科技有限公司（以下称“领易付”）并进一步授权领易付有权将上述信息提供至其合作方（北京融三六零信息技术有限公司），用于本人注册“融360”账号并向“融360”申请借款（以下称“第三方服务”）。同时，本人理解并同意领易付及其合作方获取发送短信的权限用于实名验证。为此，<strong>本人理解并同意，领易付及其合作方有权获取上述信息及权限，且有权分析、使用本人上述信息，该等分析、使用可能会影响到“融360”提供的第三方服务。</strong></p>

        <p class="text tab-2">二、 本人理解，第三方服务由北京融三六零信息技术有限公司及其合作机构等第三方服务提供方（以下称“第三方服务提供方”）提供并就以上服务及数据安全独立承担全部责任。<strong>因该第三方服务或其使用本人的信息产生的纠纷，或第三方服务违反相关法律法规，或本人在使用第三方服务过程中遭受的损失，本人将和第三方服务提供方协商解决</strong>。</p>

        <p class="text tab-2">三、 本人同意并授权被授权人基于为本人提供信息展示服务有权从北京融三六零信息技术有限公司获取本人于使用第三方服务中产生的贷款信息（包括<strong>借款金额、还款计划、逾期信息等“融360”服务页面中实际展示的内容</strong>）。</p>

        <p class="text tab-2">四、本人理解网络欺诈往往会模仿、仿冒本服务页面的样式制作视觉感相似的页面，引诱用户输入账号和密码等信息。本人承诺不向非天美贷的站点或任何人士透露本人的天美贷账号、密码等相关信息。</p>

        <p class="text tab-2">五、 本授权书未尽事宜，以天美贷平台公示的《天美贷平台用户注册协议》、《天美贷个人信息保护政策》及相关规则为准；如有冲突的，以本授权书约定为准。</p>

        <p class="text tab-2">六、 <strong>本授权书是本人向被授权人作出的单方承诺，效力具有独立性，不因其他协议的任何条款无效而无效。</strong></p>

        <p class="text tab-2">七、 本授权书授权期限为自本人作出本授权承诺之日起，至本人与被授权人及第三方服务提供方所有业务/服务终结之日止。<strong>授权期限到期后，为了后续异议或纠纷处理，本人不可撤销地同意被授权人及第三方服务提供方仍可继续留存本人的个人信息</strong>。</p>

        <p class="text tab-2">八、 本人声明已知悉并同意本授权书所载内容（特别是加粗字体内容）的含义及法律后果，自愿作出上述授权，本授权书系本人真实意思表示，本人同意承担由此带来的一切法律后果。</p>
      </div>
      <p class="text tab-2">特此授权！</p>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'vipProtocol',
  data () {
    return {
      userInfo: {}
    }
  },
  created () {
    this.$bus.$emit('ready')
    this.getDiversionInfo()
  },
  methods: {
    ...mapActions('user', ['diversionInfo']),
    async getDiversionInfo () {
      const mobile = this.$route.params.mobile
      if (mobile) {
        const { success, data } = await this.diversionInfo({
          params: { mobile }
        })
        if (success) {
          this.userInfo = data || {}
        }
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

.login-protocol {
  background-color: white;

  .content {
    padding: 0 48px;
    .title {
      font-weight: bolder;
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
      margin-top: 10px;
    }
    .text {
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
    }
    .text:last-child {
      margin-bottom: 10px;
    }
    .underline {
      text-indent: 40px;
      font-weight: bold;
      text-decoration: underline;
    }
    .underline:last-child {
      margin-bottom: 10px;
    }
  }
}
</style>
